export default class SingpassMyinfo {
    companyName? = "";
    maritalStatus? = "";
    mobileNumber? = "";
    emailAddress? = "";
    residentialStatus? = "";
    residentialAddCountry? = "";
    residentialAddHouseNo? = "";
    residentialAddStreetName? = "";
    residentialAddUnitNo? = "";
    residentialBuildingName? = "";
    residentialPostalCode? = "";
    version? = "";
}